import { FormAPI } from 'lecom-api';
import FormEvents from 'form/events/form_events';

export const execute = (action, response) => {
	const formAPI = FormAPI.form(action.formId);

	action.mappings
		.filter((mapping) => mapping.writeBack)
		.forEach(setMappedValue.bind(this, formAPI, response));

	formAPI.publish(FormEvents.SEARCHER_SELECT, response);
	return formAPI.apply();
};

const setMappedValue = (formAPI, response, mapping) => {
	const { dataStoreColumn, formField } = mapping;
	const newValue = response.resources[dataStoreColumn];
	const fieldAPI = getMappedFieldAPI(formAPI, formField);

	if((fieldAPI.component() === 'radio' || fieldAPI.component() === 'autocomplete') && Array.isArray(newValue) && (typeof newValue[0] == "object" || newValue.length <= 0))
		fieldAPI.options(newValue);	
	else if(fieldAPI.component() === 'currency' || fieldAPI.component() === 'decimal')		
		fieldAPI.value(parseFloat(newValue));		
	else
		fieldAPI.value(newValue);			
};

const getMappedFieldAPI = (formAPI, formField) => {
	return (formField.gridFormParent)
	? formAPI.fields(formField.gridFormParent).fields(formField.id)
	: formAPI.fields(formField.id);
};

export default {
	execute
};
